import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import SnackbarContent from '@material-ui/core/SnackbarContent/SnackbarContent';
import InfoTooltip from '../../common/InfoTooltip';
import { farmerModule } from 'shared/src/modules/farmerModule';

const useStyles = makeStyles((theme) => ({
    layout: {
        position: 'absolute',
        top: '10px',
        left: '5px',
        right: '5px',
        [theme.breakpoints.up('sm')]: {
            left: '50%',
            right: 'auto',
            transform: 'translateX(-50%)',
        },
        '&.MuiSnackbarContent-root': {
            backgroundColor: '#4CAF50',
        },
    },
    tooltip: {
        backgroundColor: '#333333',
        color: 'rgba(255, 255, 255, 1)',
        fontSize: '18px',
        border: '1px solid #dadde9',
        '& b': {
            fontWeight: theme.typography.fontWeightMedium,
        },
    },
}));

export default function MissingNdviMessage() {
    const classes = useStyles();
    const selectedMepar = useSelector((state) => state.mepar.selectedMepar);
    const policyPlotToDraw = useSelector((state) => state.mepar.policyPlotToDraw);

    if (!selectedMepar) {
        return null;
    }

    // we remove drawing requirement for now
    // const selectedMeparHasTableGeometries = farmerModule.meparHasSomeTableGeometries(selectedMepar);
    const ndviDates = farmerModule.getMeparNdviDates(selectedMepar) || [];

    if (policyPlotToDraw /* || !selectedMeparHasTableGeometries */ || ndviDates.length > 0) {
        return null;
    }

    return (
        <SnackbarContent
            message={'Az NDVI térkép hamarosan elérhető lesz!'}
            action={
                <>
                    <InfoTooltip
                        title={`Az NDVI (biomassza intenzitás) térkép megjelenítéséhez erre a területre még nincs aktuális felhőmentes műholdfelvétel.`}
                    />
                </>
            }
            className={classes.layout}
        />
    );
}
